import React, {cloneElement, useState, JSX} from 'react';
import classnames from 'classnames';
import Icon from 'shared/components/icon';

interface Props {
  id: string;
  children: JSX.Element;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  active?: boolean;
  errorType?: 'warning' | 'error';
}

const Card = ({id, onClick, children, active, errorType}: Props) => {
  const [hover, setHover] = useState(false);
  const isHovered = hover || active;

  return (
    <button
      id={id}
      type="button"
      className={classnames(
        'portfolio-card',
        {[`portfolio-card-${errorType}`]: errorType},
        {'portfolio-card-hover': isHovered}
      )}
      onMouseEnter={() => setHover(true)}
      onFocus={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onBlur={() => setHover(false)}
      onClick={onClick}
    >
      {isHovered && <Icon iconType="pen" className="portfolio-card-icon" />}
      {cloneElement(children, {hover: isHovered})}
    </button>
  );
};

export default Card;
